import styled from 'astroturf/react'
import { useState } from 'react'
import { useSelector } from 'react-redux'
const colorBackgroundStandard = 'var(--colorBackgroundStandard, var(--coreColorNeutral0))'
const colorStrokeFocus = 'var(--colorStrokeFocus, var(--coreColorBlue600))'
const colorStrokeMedium = 'var(--colorStrokeMedium, var(--coreColorNeutral500))'
const colorStrokeDestructive = 'var(--colorStrokeDestructive, var(--coreColorRed600))'
import { PaymentElement } from '@stripe/react-stripe-js'
import { ErrorMessage } from '@calendly/form'
import { useBooleanState } from '@calendly/hooks'

import { embedSelector } from '../../../selectors/scheduling'
import _PaymentElementWrapper from "payment_element_field-PaymentElementWrapper.module.css!=!astroturf/inline-loader?style=1!/home/runner/work/booking/booking/frontend/components/payment/stripe/payment_element_field.js?styleId=PaymentElementWrapper";


/** URL embed + custom colors: reset surface tokens so Stripe uses colorBackgroundStandard on white (see embedSelector). */
const embedCustomColorSurfaceStyle = {
  '--color-bg-white-l-1': '#ffffff',
  '--colorBackgroundStandard': '#ffffff',
}

const PaymentElementWrapper = /*#__PURE__*/styled('div', null, {
  displayName: "PaymentElementWrapper",
  styles: _PaymentElementWrapper
})

export const PaymentElementField = ({ onChange, error, disabled, ...props }) => {
  const [hasError, setHasError] = useState(false)
  const [hasFocus, focus, blur] = useBooleanState(false)
  const { color_customization: embedCustomColors } = useSelector(embedSelector)

  const handleChange = (changeObject) => {
    setHasError(Boolean(changeObject.error))
    onChange(changeObject)
  }

  const paymentElementOptions = {
    paymentMethodOrder: [
      'card',
      'apple_pay',
      'google_pay',
      'pay_by_bank'
    ]
  }

  return (
    <div {...props}>
      <PaymentElementWrapper
        hasError={hasError}
        hasFocus={hasFocus}
        onChange={handleChange}
        onFocus={focus}
        onBlur={blur}
        style={embedCustomColors ? embedCustomColorSurfaceStyle : undefined}
      >
        <PaymentElement options={paymentElementOptions} />
      </PaymentElementWrapper>
      <ErrorMessage message={error} />
    </div>
  )
}
